import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../state";

export const getTeam = createAsyncThunk('getTeam', async () => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/team'
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const createTeam = createAsyncThunk('createTeam', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/team',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const deleteTeam = createAsyncThunk('deleteTeam', async (id: string) => {
    try {
        const response = await axios({
            method: 'delete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/team?id=' + id,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editTeam = createAsyncThunk('editTeam', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/team',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})